import NoticeList from 'components/board/noticeList';

import PageTab from "components/common/pageTab";
import TopImage from 'components/common/topImage';

import 'assets/css/notice.scss';

import {pageMenuTabList06} from 'types/common';

const NoticeNews = () => {

  pageMenuTabList06[1].on = true;

  return (
    <div className="page_content">
      <TopImage imgUrl="https://img.chunhomall.com/images/brand_site/notice-hero_1920x1080.jpg.jpg"  imgText="공지사항" textcolor="#FFF"></TopImage>
      <PageTab props={pageMenuTabList06}></PageTab>

      <div className="container">

        <div className="container-title">
          천호엔케어 소식을 전합니다.
        </div>

      </div>

      <NoticeList intType={1} />
    </div>
  );
};

export default NoticeNews;
